(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
class ImageWithTextSlider extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.carousel = this.querySelector('carousel-slider');
    this.slider = this.querySelector('.image-text-slider__slider');
    this.slides = Array.from(this.querySelectorAll('.image-text-slider__slide'));
    this.pagination = Array.from(this.querySelectorAll('.image-text-slider__pagination-button'));
    this.paginationContainer = this.querySelector('.image-text-slider__pagination');
    this.animateElement = this.querySelector('.image-text-slider__animate-element');

    if (!this.carousel || !this.slider || !this.slides.length) return;

    this.handleClick = this.handleClick.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handlePaginationMouseDown = this.handlePaginationMouseDown.bind(this);
    this.handlePaginationMouseMove = this.handlePaginationMouseMove.bind(this);
    this.handlePaginationMouseUp = this.handlePaginationMouseUp.bind(this);
    this.addEventListener('click', this.handleClick);
    this.carousel.addEventListener('on:carousel-slider:select', this.handleSelect);
    this.slider.addEventListener('scroll', this.handleScroll, { passive: true });
    this.paginationContainer?.addEventListener('mousedown', this.handlePaginationMouseDown);
    this.paginationContainer?.addEventListener('mousemove', this.handlePaginationMouseMove);
    this.paginationContainer?.addEventListener('mouseup', this.handlePaginationMouseUp);
    this.paginationContainer?.addEventListener('mouseleave', this.handlePaginationMouseUp);
    window.addEventListener('resize', this.handleResize);
    this.update(0, false);
    this.initialized = true;
  }

  disconnectedCallback() {
    if (!this.initialized) return;
    this.removeEventListener('click', this.handleClick);
    this.carousel.removeEventListener('on:carousel-slider:select', this.handleSelect);
    this.slider.removeEventListener('scroll', this.handleScroll);
    this.paginationContainer?.removeEventListener('mousedown', this.handlePaginationMouseDown);
    this.paginationContainer?.removeEventListener('mousemove', this.handlePaginationMouseMove);
    this.paginationContainer?.removeEventListener('mouseup', this.handlePaginationMouseUp);
    this.paginationContainer?.removeEventListener('mouseleave', this.handlePaginationMouseUp);
    window.removeEventListener('resize', this.handleResize);
    clearTimeout(this.scrollEndTimer);
    this.initialized = false;
  }

  handleClick(event) {
    const button = event.target.closest('[data-slide-to]');
    if (!button || !this.contains(button)) return;
    if (this.paginationDragged) {
      event.preventDefault();
      this.paginationDragged = false;
      return;
    }

    const index = Number(button.dataset.slideTo);
    const left = this.slides[index].offsetLeft - this.slides[0].offsetLeft;
    this.slider.scrollTo({ left, behavior: 'smooth' });
    this.update(index);
  }

  handleSelect(event) {
    this.update(this.isAtScrollEnd() ? this.slides.length - 1 : event.detail.index);
  }

  handleScroll() {
    clearTimeout(this.scrollEndTimer);
    this.scrollEndTimer = setTimeout(() => {
      if (this.isAtScrollEnd()) {
        this.update(this.slides.length - 1);
        return;
      }

      const sliderLeft = this.slider.getBoundingClientRect().left;
      const index = this.slides.reduce((closestIndex, slide, slideIndex) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - sliderLeft);
        const closestDistance = Math.abs(this.slides[closestIndex].getBoundingClientRect().left - sliderLeft);
        return distance < closestDistance ? slideIndex : closestIndex;
      }, 0);

      this.update(index);
    }, 120);
  }

  isAtScrollEnd() {
    const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
    return Math.abs(this.slider.scrollLeft) >= maxScrollLeft - 2;
  }

  handleResize() {
    this.positionAnimateElement(this.pagination.findIndex((button) => button.classList.contains('is-active')), false);
  }

  handlePaginationMouseDown(event) {
    if (event.button !== 0) return;
    this.paginationMouseDown = true;
    this.paginationDragged = false;
    this.paginationStartX = event.pageX;
    this.paginationStartScrollLeft = this.paginationContainer.scrollLeft;
    this.paginationContainer.classList.add('is-dragging');
  }

  handlePaginationMouseMove(event) {
    if (!this.paginationMouseDown) return;
    const distance = event.pageX - this.paginationStartX;
    if (Math.abs(distance) <= 5) return;

    event.preventDefault();
    this.paginationDragged = true;
    this.paginationContainer.scrollLeft = this.paginationStartScrollLeft - distance;
  }

  handlePaginationMouseUp() {
    if (!this.paginationMouseDown) return;
    this.paginationMouseDown = false;
    this.paginationContainer.classList.remove('is-dragging');
  }

  update(index, animate = true) {
    this.pagination.forEach((button, buttonIndex) => {
      const active = buttonIndex === index;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active.toString());
    });

    this.positionAnimateElement(index, animate);

    const activeButton = this.pagination[index];
    const pagination = activeButton?.parentElement;
    if (!activeButton || !pagination) return;

    const isMobilePagination = window.matchMedia('(max-width: 749px)').matches;
    const left = isMobilePagination
      ? activeButton.offsetLeft - (parseFloat(getComputedStyle(pagination).paddingLeft) || 0)
      : activeButton.offsetLeft - (pagination.clientWidth - activeButton.offsetWidth) / 2;
    pagination.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }

  positionAnimateElement(index, animate = true) {
    const button = this.pagination[index];
    if (!button || !this.animateElement) return;

    this.animateElement.style.transition = animate ? '' : 'none';
    this.animateElement.style.width = `${button.offsetWidth}px`;
    this.animateElement.style.transform = `translate(${button.offsetLeft}px, -50%)`;

    if (!animate) requestAnimationFrame(() => this.animateElement.style.removeProperty('transition'));
  }
}

if (!customElements.get('image-with-text-slider')) {
  customElements.define('image-with-text-slider', ImageWithTextSlider);
}

},{}]},{},[1])

